if (!customElements.get("product-card")) {
  customElements.define(
    "product-card",
    class ProductCard extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (typeof Swiper === "undefined") return;

        const sliderEl = this.querySelector(".card-product__slider");
        if (!sliderEl) return;

        this.swiper = new Swiper(sliderEl, {
          direction: "horizontal",
          loop: true,
          speed: 300,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          a11y: {
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
          },
          navigation: {
            enabled: false,
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          },
          breakpoints: {
            769: {
              navigation: {
                enabled: true,
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            },
          },
        });

        const desktopMQ = window.matchMedia("(min-width: 990px)");
        this.addEventListener("mouseenter", () => {
          if (desktopMQ.matches && this.swiper && this.swiper.slides.length > 1) {
            this.swiper.slideTo(1);
          }
        });
        this.addEventListener("mouseleave", () => {
          if (desktopMQ.matches && this.swiper) {
            this.swiper.slideTo(0);
          }
        });
      }
    },
  );
}
